import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconFileLaz.tsx
const IconFileLaz = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ jsx("path", {
			fill: "#ece5e3",
			d: "M2 2h11.5v4A1.5 1.5 0 0 0 15 7.5h4V8h-9a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h9v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1"
		}),
		/* @__PURE__ */ jsx("path", {
			fill: "#ece5e3",
			d: "M14.5 2.5V6a.5.5 0 0 0 .5.5h3.5z"
		}),
		/* @__PURE__ */ jsx("path", {
			fill: "#deae02",
			fillRule: "evenodd",
			d: "M10 9a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1zm7.99 6.088h3.175v-.81h-2.118l2.07-2.568v-.81h-3.024v.81h1.962l-2.064 2.568zm-1.299 0-.3-.996h-1.398l-.3.996h-.924l1.38-4.188h1.128l1.362 4.188zm-1.02-3.36h.03l.468 1.59h-.96zm-4.84-.828v4.188h2.507v-.81h-1.596V10.9z",
			clipRule: "evenodd"
		})
	]
});
var IconFileLaz_default = forwardRef(IconFileLaz);
//#endregion
export { IconFileLaz_default as default };
